export default __webpack_public_path__ + "static/media/Leetcode.e734dbd0.png";